/*
 * Purpose: MCP probe API client — same-origin /api/mcp/probe
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { apiUrl } from '@/lib/apiBase';
import type { McpInvokeResult, McpProbeResult } from '@/services/connectors/mcp/types';

export async function probeMcpServer(
  serverUrl: string,
  authToken?: string | null,
): Promise<McpProbeResult> {
  const res = await fetch(apiUrl('/api/mcp/probe'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      serverUrl: serverUrl.trim(),
      authToken: authToken?.trim() || undefined,
    }),
  });

  const json = (await res.json()) as McpProbeResult;
  if (!res.ok) {
    return {
      ok: false,
      error: json.error || 'MCP probe failed',
      action: json.action ?? { label: 'Open MCP setup', href: '/connect/mcp' },
    };
  }
  return { ...json, ok: true };
}

export async function invokeMcpServer(
  serverUrl: string,
  rpcMethod: string,
  params: Record<string, unknown> = {},
  authToken?: string | null,
): Promise<McpInvokeResult> {
  const res = await fetch(apiUrl('/api/mcp/invoke'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      serverUrl: serverUrl.trim(),
      authToken: authToken?.trim() || undefined,
      method: rpcMethod,
      params,
    }),
  });

  const json = (await res.json()) as McpInvokeResult;
  if (!res.ok) {
    return {
      ok: false,
      error: json.error || 'MCP invoke failed',
      action: json.action ?? { label: 'Open MCP setup', href: '/connect/mcp' },
    };
  }
  return { ...json, ok: true };
}
